import { AuthApiPath } from "../../../constants";
import { portalPrivateApi } from "../../../core/http/portal-axios.instance";
import { publicApi } from "../../../core/http";
import { usePortalAuthStore } from "../../../core/stores/auth/portal-auth.store";
/**
 * Login portal user — POST /api/auth/portal/login
 */
export const loginPortalUser = async (values) => {
    const response = await publicApi.post(AuthApiPath.PORTAL_LOGIN, {
        user_cms: values.user_cms,
        password_cms: values.password_cms,
    });
    if (response.status !== 200 && response.status !== 202) {
        throw response;
    }
    return response.data;
};
/**
 * Logout portal user — POST /api/auth/logout
 * Mengirimkan refreshToken sesuai kebutuhan validasi Backend
 */
export const logoutPortalUser = async () => {
    const refreshToken = usePortalAuthStore.getState().refreshToken;
    await portalPrivateApi().post(AuthApiPath.PORTAL_LOGOUT, refreshToken ? { refreshToken } : {});
};
/**
 * Refresh token secara manual untuk Portal
 */
export const refreshTokenPortalService = async () => {
    const refreshToken = usePortalAuthStore.getState().refreshToken;
    const res = await publicApi.post(AuthApiPath.PORTAL_REFRESH_TOKEN, refreshToken ? { refreshToken } : {});
    return res.data.data;
};
/**
 * Ubah kata sandi portal user
 */
export const changePortalPassword = async (payload) => {
    await portalPrivateApi().post("/auth/portal/password/change", payload);
};
/**
 * Ubah username portal user (user_cms)
 */
export const changePortalUsername = async (payload) => {
    await portalPrivateApi().post("/auth/portal/username/change", payload);
};
/**
 * Fetch daftar profil terkait (anak) untuk Nasabah Utama (Orang Tua).
 */
export const fetchTerkaitList = async () => {
    const response = await portalPrivateApi().get("/customer/portal/relasi/terkait");
    // WebResponse: { data: [...] }
    return response.data?.data || [];
};
/**
 * Switch Profile: ganti JWT aktif dengan JWT atas nama Nasabah Terkait.
 */
export const switchProfile = async (idNasabahTerkait) => {
    const response = await portalPrivateApi().post("/auth/portal/switch-profile", {
        idNasabahTerkait,
    });
    // WebResponse: { data: PortalLoginResponseData }
    return response.data?.data;
};
